import { createAction } from '@reduxjs/toolkit';

import type {
    ActionPayloads,
    BgProcessFinishedPayload,
    BgProcessUpdatedPayload,
    ItemCompletePayload,
    LanguageCompletePayload,
} from './socketTypes';

export const taskItemComplete = createAction<ItemCompletePayload>('socket/TASK_ITEM_COMPLETE');
export const taskLangComplete = createAction<LanguageCompletePayload>('socket/TASK_LANG_COMPLETE');
export const taskCreated = createAction<void>('socket/TASK_CREATED');
export const taskLanguageAssigneesChanged = createAction<void>('socket/TASK_LANGUAGE_ASSIGNEES_CHANGED');
export const taskClosed = createAction<void>('socket/TASK_CLOSED');
export const taskDeleted = createAction<void>('socket/TASK_DELETED');

export const bgProcessCountChanged = createAction<void>('socket/bg_process_count_changed');
export const bgProcessUpdated = createAction<BgProcessUpdatedPayload>('socket/bg_process_updated');
export const bgProcessFinished = createAction<BgProcessFinishedPayload>('socket/bg_process_finished');
export const translationEditStart = createAction<{ translationId: number }>('socket/translation_edit_start');

const socketActions = {
    taskItemComplete,
    taskLangComplete,
    taskCreated,
    taskLanguageAssigneesChanged,
    taskClosed,
    taskDeleted,
    bgProcessCountChanged,
    bgProcessUpdated,
    bgProcessFinished,
    translationEditStart,
};

export type SocketActionsType = typeof socketActions;

export const createSocketAction = <T extends keyof SocketActionsType>(actionName: T, payload: ActionPayloads[T]) =>
    socketActions[actionName](payload as never);
